import { render } from "./ProductTabaccordion.vue?vue&type=template&id=2c2415cb&scoped=true"
import script from "./ProductTabaccordion.vue?vue&type=script&lang=js"
export * from "./ProductTabaccordion.vue?vue&type=script&lang=js"

import "./ProductTabaccordion.vue?vue&type=style&index=0&id=2c2415cb&scoped=true&lang=css"
import "./ProductTabaccordion.vue?vue&type=style&index=1&id=2c2415cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2415cb"]])

export default __exports__